<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.cons{
  display: none;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/img/产品及服务/基因调控/甲基化检测/banner.png" class="img-fluid">-->
<!--      <div class="info">-->

<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>甲基化检测</h1>
      <h2 class="mt10">Methylation Detection</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc">DNA甲基化（DNA methylation）为DNA化学修饰的一种形式，能够在不改变DNA序列的前提下，改变遗传表现。所谓DNA甲基化是指在DNA甲基化转移酶的作用下，在基因组CpG二核苷酸的胞嘧啶5号碳位共价键结合一个甲基基团。大量研究表明，DNA甲基化能引起染色质结构、DNA构象、DNA稳定性及DNA与蛋白质相互作用方式的改变，从而控制基因表达。</p>
        <div class="gene_img con" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;"><img src="@/assets/img/产品及服务/基因调控/甲基化检测/jia1.jpg"  style="margin-bottom: 20px;"></div>
        <div class="gene_img cons" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;"><img src="@/assets/img/产品及服务/基因调控/甲基化检测/jia1_2.jpg"  style="margin-bottom: 20px;"></div>
        <p style="text-align: center;margin-bottom: 20px;">胞嘧啶和甲基胞嘧啶</p>
        <p class="desc">早期对甲基化的检测，主要靠BSP、MSP等方法，低效繁杂还不准确，随着高通量测序技术的发展，高通量测序技术也可以被用在甲基化检测领域。</p>
        <p class="desc">一般情况下，基因的启动子位置会有连续的CpG，称为CpG岛，它们通常处于非甲基化状态。相反，非CpG岛的CpG通常都是处于甲基化修饰状态。若CpG岛发生了非正常的甲基化，那么就会导致基因表达异常降低。或者其他位置CpG降低导致基因表达异常升高。</p>
        <p class="desc">擎科生物可提供甲基化靶向捕获测序技术，此方法适合一个到上千个靶序列的甲基化检测，使用非常灵活。</p>
      </div>
      <div class="container">
        <div class="c-title">技术流程<small>Technical processes</small></div>
        <div class="gene_img con" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;margin-bottom: 30px;"><img src="@/assets/img/产品及服务/基因调控/甲基化检测/jia2.jpg"  style="margin-bottom: 20px;"></div>
        <div class="gene_img cons" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;margin-bottom: 30px;"><img src="@/assets/img/产品及服务/基因调控/甲基化检测/jia2_2.jpg"  style="margin-bottom: 20px;"></div>
        <p class="desc" style="text-indent: 0">1.DNA提取：提取DNA、进行重亚硫酸盐处理，非甲基化的C都会变成U。</p>
        <p class="desc" style="text-indent: 0">2.靶向捕获文库制备：将靶向区域富集之后进行捕获后扩增。U被扩增后变成T碱基。</p>
        <p class="desc" style="text-indent: 0">3.文库质检：先使用 Qubit 2.0 进行初步定量，随后使用 Agilent 2100 对文库的 insert size 进行检测，insert size 符合预期后，使用 Q-PCR 方法对文库的有效浓度(2 nM)进行准确定量，以保证文库质量。</p>
        <p class="desc" style="text-indent: 0">4.上机测序：根据文库的有效浓度及数据产出需求进行 Illumina Novaseq PE150 测序。 </p>
        <p class="desc" style="text-indent: 0">5.生物信息分析</p>
        <p class="desc" style="margin-top: 50px;text-indent: 0">说明：通常我们会选择基因启动子位置2000 bp范围内的CpG道进行甲基化检测；但某些情况下，导致基因表达异常的甲基化位点可能并非处于CpG岛内。我们也可以对启动子2000 bp范围内所有CpG还有基因本体进行甲基化检测。采用捕获测序的方法也不会增加太多的研究成本。</p>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Methylation_detection.vue